import * as React from 'react';
import { useTranslation } from '@omilia/providers';
import { NotificationInfoIcon } from '@omilia/icon';
import { colors } from '@omilia/theme';
import AgentWarning from '../components/AgentWarning';

const AgentTimeoutNotification = () => {
  const { t } = useTranslation();

  return (
    <AgentWarning
      dataTest="agent-timeout-notification"
      icon={<NotificationInfoIcon size="16" color={colors.COLOR_ORANGE_900} />}
      description={t('messages.agentTimeout')}
      inline
    />
  );
};

export default AgentTimeoutNotification;
